import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { IDbContext } from './database-context.interface';
import { DATABASE_CONFIG_TOKEN, LocalStore } from './config/database-config-token';

export function provideDatabase(configs: Record<LocalStore, IDbContext>): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: DATABASE_CONFIG_TOKEN, useValue: configs }
	]);
}
